/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

export default [
	{
		id: 'widget.legend.display',
		value: false
	}
];



// WEBPACK FOOTER //
// ./src/js/constants/RECOMMENDATION_PROPERTIES.js